import { request } from "_utilities/request";
import { setEnrollmentStepGs1, startEnrollmentStepGs1 } from "./store/enrollmentStepGs1.slice";
import { setCreateAccountGs1, startCreateAccountGs1 } from "./store/createAccount";

export const enrollmentStepGs1Thunk = (_id, post, extras = {}) =>
  async (dispatch) => {
    dispatch(startEnrollmentStepGs1());
    const res = await request({
      endpoint: "/enrollment/process/step",
      type: "put",
      params: { _id },
      data: post,
      ...extras
    });
    const { data, error } = res;
    dispatch(setEnrollmentStepGs1({ data, error }));
    return res;
  };

export const createAccountGs1Thunk = (params, extras = {}) =>
  async (dispatch) => {
    dispatch(startCreateAccountGs1());
    let res = await request({
      endpoint: "/onboarding/process/start",
      type: "post",
      params,
      ...extras
    });
    let { data, error } = res;
    dispatch(setCreateAccountGs1({ data, error }));
    return res;
  };
